import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"


export default function AppWebSuppliersAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		multiple
		label="Web suppliers"
		placeholder="All Web suppliers"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/web_suppliers`}
		{...props}
	/>
}